import { getIsVenue } from '@bridebook/web/app-basic/lib/supplier/selectors';
import { useSelector } from '@bridebook/web/app-basic/lib/utils';
import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';
import ToggleEnquiryFormWithSignup from './toggle-enquiry-form-with-signup';
import { Button, ButtonProps } from '@bridebook/aura';
import { Send } from '@bridebook/aura/src/icons';

type Props = {
  contactMethod: string;
} & ButtonProps;

/**
 * Renders a button that toggles the supplier enquiry form with signup.
 * It's using asChild on ToggleEnquiryFormWithSignup component, so there is no extra onClick wrapper.
 * The Button is what is triggering the modal to open.
 */

export const ToggleEnquiryFormButtonAura = ({ contactMethod, ...props }: Props) => {
  const { t } = useTranslation();
  const isVenue = useSelector(getIsVenue);
  const enquiryCTAText = useMemo(
    () => (isVenue ? t('common:cta.requestBrochure') : t('common:enquiryCTA.nonVenue')),
    [isVenue, t],
  );

  return (
    <ToggleEnquiryFormWithSignup contactMethod={contactMethod} asChild>
      <Button
        data-name="supplier-profile-enquiry-toggle-button"
        data-test="supplier-profile-enquiry-toggle-button"
        size="standard"
        variant="primary"
        icon={Send}
        {...props}>
        {enquiryCTAText}
      </Button>
    </ToggleEnquiryFormWithSignup>
  );
};
